module.exports = __webpack_public_path__ + "static/media/x_logo.951227fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/details/imgs/x_logo.png
// module id = 1161
// module chunks = 0